'use client'

import { useAuth } from '@/providers/AuthProvider'
import { routes } from '@/utils/routes'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function GuestGuard({ children }: React.PropsWithChildren) {
  const { isAuthenticated } = useAuth()
  const route = useRouter()

  useEffect(() => {
    if (isAuthenticated) {
      route.push(routes.admin)
    }
  }, [isAuthenticated, route])

  return children
}
